import { create } from 'zustand';
import { api, fromUnix } from '@/lib/api';
import type { ApiResponse, DashboardStats, AuditLogEntry } from '@nexus/shared/types';

interface RecentActivity {
  id: string;
  type: string;
  title: string;
  summary: string;
  timestamp: string;
}

interface DashboardState {
  stats: DashboardStats | null;
  recentActivity: RecentActivity[];
  isLoading: boolean;
  error: string | null;
  fetchDashboard: () => Promise<void>;
}

export const useDashboardStore = create<DashboardState>((set) => ({
  stats: null,
  recentActivity: [],
  isLoading: false,
  error: null,

  fetchDashboard: async () => {
    set({ isLoading: true, error: null });
    try {
      const [statsRes, auditRes] = await Promise.all([
        api.get<ApiResponse<DashboardStats>>('/api/dashboard/stats'),
        api.get<ApiResponse<AuditLogEntry[]>>('/api/audit?perPage=10').catch(() => ({ data: [] as AuditLogEntry[] })),
      ]);
      const activity: RecentActivity[] = (auditRes.data ?? []).map((e) => ({
        id: e.id,
        type: e.action,
        title: `${e.action} ${e.entityType}`,
        summary: typeof e.changes === 'object' && e.changes ? JSON.stringify(e.changes).slice(0, 120) : `${e.entityType} ${e.entityId}`,
        timestamp: fromUnix((e as unknown as Record<string, unknown>).createdAt as number),
      }));
      set({ stats: statsRes.data ?? null, recentActivity: activity, isLoading: false });
    } catch (err: unknown) {
      set({ error: (err as Error).message, isLoading: false });
    }
  },
}));
